(function() {
    "use strict";

    document.querySelectorAll(".find-resources__form").forEach((form) => {
      form.addEventListener("submit", (e) => {
        e.preventDefault();
        const zipcode = form.querySelector("#zipcode-input").value;
        window.location.href = `https://familyreach.findhelp.com/search_results/${zipcode}`;
      });
    });
  
  })();